import watch from 'redux-watch'
import LinkTextOverrideResponseHandler from './response-handler-links'
import { settings } from '../../../settings/settings-util'

export default class LanguageSpecificSettingsOverride {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._linkTextOverrideResponseHandler = new LinkTextOverrideResponseHandler(settings);
    }

    static getDefaultSettings()
    {
        return settings;
    }

    initialize(store) {
        this._store = store;
        this._linkTextOverrideResponseHandler.initialize(store);

        let base = this._settings.stateLocations.Conversation.Base;
        let location = this._settings.stateLocations.Conversation.language;

        let watchStateLocation = `${base}.${location}`

        let watcher = watch(this._store.getState, watchStateLocation);
        this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
            return this.updateSettings(newVal);
        }));

    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    getLinkOverrideResponseHandler() {
        return this._linkTextOverrideResponseHandler;
    }

    updateSettings(value) {
        if (value in this._settings.languageSpecificSettingOverrides) {
            for (var key in this._settings.languageSpecificSettingOverrides[value]) {
                if (this._settings.languageSpecificSettingOverrides[value].hasOwnProperty(key)) {

                    this.setNestedProperty(this._settings, key, this._settings.languageSpecificSettingOverrides[value][key]);                
                }
            }
        }
    }

    setNestedProperty(obj, path, val){

        let splitPath = path.split('.');

        let curStep = splitPath.shift()

        if(splitPath.length > 0){

            this.setNestedProperty(obj[curStep], splitPath.join('.'), val);
        }
        else{
            obj[curStep] = val;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/language-specific-settings-override/src/language-specific-settings-override.js